var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgEs(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M2 5h20v13H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.095 5H3.905C2.853 5 2 5.776 2 6.733v9.534C2 17.224 2.853 18 3.905 18h16.19C21.147 18 22 17.224 22 16.267V6.733C22 5.776 21.147 5 20.095 5z",
    fill: "#F93939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.467h20v6.066H2V8.467z",
    fill: "#FFDA2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.571 10.392v2.184c0 .607-.64 1.092-1.428 1.092H7.238c-.787-.001-1.428-.49-1.428-1.093V10.39c0-.496.426-.91 1.013-1.045C7 8.896 7.545 9.3 8.19 9.3c.65 0 1.191-.402 1.368.047.585.138 1.013.553 1.013 1.045z",
    fill: "#D4AF2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.571 11.067h.953v2.6h-.953v-2.6zm-5.714 0h.953v2.6h-.953v-2.6z",
    fill: "#CBCBCB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.571 12.8h.953v.867h-.953V12.8zm-5.714 0h.953v.867h-.953V12.8z",
    fill: "#1A47B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.571 10.2h.953v.867h-.953V10.2zm-5.714 0h.953v.867h-.953V10.2z",
    fill: "#D4AF2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.762 10.2h.952v1.3h-.952v-1.3zm1.905 1.733h.952v1.3h-.952v-1.3z",
    fill: "#AF010D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.667 10.2h.952v1.3h-.952v-1.3z",
    fill: "#AE6A3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.762 11.933h.952v1.3h-.952v-1.3z",
    fill: "#FFDA2C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.714 10.2l-.952-.867h2.857l-.952.867h-.953z",
    fill: "#AF010D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.714 8.467h.953v.866h-.953v-.866z",
    fill: "#D4AF2C"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 5)",
    d: "M0 0h20v13H0z"
  })))));
}
export default SvgEs;